import _ from 'lodash';
import React from 'react';

import { Translate } from '../../components/translate/translate';
import { NAVIGATION } from '../../config';
import { Project } from '../../types/entities';

import { SidebarMenuItem } from './sidebar.types';

const allowed: (hasPermissions: boolean) => boolean = (
  hasPermissions: boolean,
): boolean => hasPermissions;

const allowedWithSelectedProject = (
  hasPermissions: boolean,
  project: Project,
) => {
  return hasPermissions && !_.isEmpty(project);
};

export const ORGANIZATION_LEVEL_MENU_ITEMS: SidebarMenuItem[] = [
  {
    title: <Translate transKey="state.projects" />,
    id: 'projects',
    path: NAVIGATION.PROJECTS_STATE,
    isAllowed: allowed,
  },
  {
    title: <Translate transKey="state.team" />,
    id: 'team',
    path: NAVIGATION.TEAM_STATE,
    isAllowed: allowed,
  },
];

export const PROJECT_LEVEL_MENU_ITEMS: SidebarMenuItem[] = [
  {
    title: <Translate transKey="state.project-overview" />,
    id: 'projectOverview',
    path: NAVIGATION.PROJECT_OVERVIEW,
    isAllowed: allowed,
  },
  {
    title: <Translate transKey="state.file-manager" />,
    id: 'fileManager',
    path: NAVIGATION.FILE_MANAGER,
    isAllowed: allowedWithSelectedProject,
  },
  {
    title: <Translate transKey="state.applications" />,
    id: 'applications',
    path: NAVIGATION.APPLICATION_STATE,
    isAllowed: allowed,
    subPaths: [NAVIGATION.APPLICATION_OVERVIEW_STATE],
  },
  {
    title: <Translate transKey="state.replications" />,
    id: 'replications',
    path: NAVIGATION.REPLICATIONS_STATE,
    isAllowed: allowedWithSelectedProject,
  },
  {
    title: <Translate transKey="state.jobs" />,
    id: 'jobs',
    path: NAVIGATION.JOBS_STATE,
    isAllowed: allowedWithSelectedProject,
  },
  {
    title: <Translate transKey="state.flows" />,
    id: 'flows',
    path: NAVIGATION.FLOWS_STATE,
    isAllowed: allowed,
  },
  {
    title: <Translate transKey="state.live-streams" />,
    id: 'liveStreams',
    path: NAVIGATION.LIVE_STREAMS,
    isAllowed: allowedWithSelectedProject,
  },
];
